// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c6CMr{display:flex;flex-direction:row;gap:24px}.c6CMr .W34dS{width:512px}.c6CMr>:last-child{flex:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"firstRow": `c6CMr`,
	"typeInput": `W34dS`
};
export default ___CSS_LOADER_EXPORT___;
